import React from "react";
var Raw = function (_a) {
    var children = _a.children;
    return (React.createElement("code", null,
        React.createElement("pre", null, JSON.stringify(children, undefined, 4))));
};
export default Raw;
